import styled, { keyframes } from 'styled-components'


export const StakeItem = styled.div`
	flex: 1;
	height: 300px;
	display: flex;
	align-items: center;
	background-color: ${({ theme }) => theme.newBg2};
	position: relative;
	margin: 1rem;
	padding: 1rem;
	border-radius: 1rem;
	box-shadow: ${({ theme }) => theme.boxShadow};
	//min-width: 300px;
	width: 800px;
	transition: all 0.3s ease-in-out;

	

	${({ theme }) => theme.mediaWidth.upToMedium`
		flex-direction: column;
		height: 450px;
		width: 300px;
	`}

	.rewardMultiplier {
		position: absolute;
		left: -10px;
		top: -10px;
		border-radius: 50%;
		background-color: ${({ theme }) => theme.newBg1};
		padding: 0.5rem;
		font-weight: bold;
		color: #ffffff;
		height: 40px;
		width: 40px;
		text-align: center;
	}

	.stakeInfo {
		margin: 0 1rem;
		min-height: 100px;
		flex: 1;

		.stakeName {
			font-size: 1.2rem;
			font-weight: bold;
			margin-bottom: 1rem;
		}

		.stakedInfoItem {
			display: flex;
			justify-content: space-between;
			margin-bottom: 10px;
			font-size: 0.9rem;
		}
	}

	.stakeButtons {
		display: flex;
		flex-direction: column;
		margin: 1rem 0;
		min-width: 170px;
		.stakeCountdown {
			background: ${({ theme }) => theme.newBg1};
			box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
			border-radius: 5px;
			color: #fff;
			padding: 10px;
			font-size: 14px;
			margin-bottom: 1rem;
		}
	}

`;

export const StakeLogo = styled.div`
	height: 150px;
	width: 150px;
	padding: 1rem;
	display: flex;
	margin: 0 1rem;
	justify-content: center;
	align-items: center;
	box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
	border-radius: 1rem;
	overflow: hidden;
	background-color: ${({ theme }) => theme.newBg2};
	
	img {
		max-height: 150px;
		max-width: 150px;
	}
`;

export const StakeCard = styled.div`
  min-width: 288px;
  max-width: 393px;
  background-color: ${({ theme }) => theme.bg1};
  padding: 1rem;
  position: relative;
  height: 472px;

  .rewardMultiplier {
    position: absolute;
    right: -10px;
    top: -10px;
    border-radius: 100%;
    background-color: #3d5a80;
    padding: 0.7rem;
    font-weight: bold;
    color: #ffffff;
  }

  .stakeLogoCounter {
    position: relative;

    .stakeLogo {
      height: 250px;
      display: flex;
      justify-content: center;
      align-items: center;

      img {
        max-height: 250px;
        max-width: 302px;
      }
    }

    .stakeCountdown {
      position: absolute;
      bottom: 0;
      z-index: 10;
      background: ${({ theme }) => theme.bg7};
      border-radius: 5px;
      color: #fff;
      padding: 10px;
      font-size: 14px;
    }
  }

  .stakeName {
    width: 100%;
    text-align: center;
    margin-top: 10px;
    font-size: 1.2rem;
    font-weight: bold;
  }

  .stakeInfo {
    margin: 10px 0;
    min-height: 100px;

    .stakedInfoItem {
      display: flex;
      justify-content: space-between;
      margin-bottom: 10px;
      font-size: 0.9rem;
    }
  }

  .stakeButtons {
    width: 100%;

    .manageButton {
      width: 100%;
      text-align: center;
      background: ${({ theme }) => theme.bg6};
      color: #fff;
      padding: 0.5rem;
      margin-top: 0.5rem;
      font-weight: bold;
      cursor: pointer;
      user-select: none;
      display: flex;
      justify-content: center;
      align-items: center;
      text-decoration: none;

      :hover {
        background: ${({ theme }) => theme.bg7};
      }
    }
  }
`
